import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, KiloGLMFlow, KiloGLMFlowWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateKiloGLMFlows(): UseMutationResult<
  AxiosResponse<KiloGLMFlow>,
  AxiosError<ErrorMessage>,
  KiloGLMFlowWrite
> {
  const queryClient = useQueryClient();

  const createKiloGLMFlow = (glmFlow: KiloGLMFlowWrite): Promise<AxiosResponse<KiloGLMFlow>> => {
    return client.post('kilo-glm-flows/', glmFlow);
  };

  return useMutation(createKiloGLMFlow, {
    onSuccess: () => {
      queryClient.invalidateQueries('kilo-glm-flows');
    },
  });
}
